import { faUserCheck, faUserXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Col, Form, Row, Table, Pagination } from "react-bootstrap";
import Select from "react-select";
import { GetAttendenceList } from "../../../features/admin/attendence/Slice";
import { useDispatch, useSelector } from "react-redux";

const Attendance_List = () => {
  const dispatch = useDispatch();

  // const [room, setRoom] = useState(null);
  // const [studentName, setStudentName] = useState("");
  // const [fromDate, setFromDate] = useState("");
  // const [toDate, setToDate] = useState("");

  const handleReset = () => {
    setName("");
    setDate("");
    setAttendance("");

    fetch(1);
  };

  const [name, setName] = useState("");
  const [date, setDate] = useState("");
  const [attendance, setAttendance] = useState("");

  const Attendence = useSelector((state) => state.attendence.attendence);

  const fetch = async (page = 1) => {
    await dispatch(
      GetAttendenceList({
        name: name || "",
        date: date || "",
        attendance: attendance || "",
        page,
        per_page: 10,
      }),
    );
  };

  useEffect(() => {
    fetch(1);
  }, [name, date, attendance]);

  const handleCustomerPageChange = (page) => {
    if (page < 1) return;

    fetch(page);
  };

  const renderPagination = (data, handlePageChange) => {
    if (!data) return null;

    const currentPage = Number(data.current_page || 1);
    const perPage = Number(data.per_page || 10);
    const total = Number(data.total || 0);

    const lastPage = Math.ceil(total / perPage);

    if (lastPage <= 1) {
      return null;
    }

    return (
      <div className="d-flex justify-content-end mt-3">
        <Pagination>
          <Pagination.Prev
            disabled={currentPage === 1}
            onClick={() => handlePageChange(currentPage - 1)}
          />

          {Array.from({ length: lastPage }, (_, index) => {
            const page = index + 1;

            return (
              <Pagination.Item
                key={page}
                active={page === currentPage}
                onClick={() => handlePageChange(page)}
              >
                {page}
              </Pagination.Item>
            );
          })}

          <Pagination.Next
            disabled={currentPage === lastPage}
            onClick={() => handlePageChange(currentPage + 1)}
          />
        </Pagination>
      </div>
    );
  };

  return (
    <section className="Attendance_List common_section">
      <div className="sectin_top">
        <h2 className="section_name">Attendance List</h2>
      </div>

      <div className="attendance_summary_section">
        <Row className="attendance_summary_row">
          <Col
            xl={3}
            lg={3}
            md={4}
            sm={6}
            xs={12}
            className="attendance_summary_col mb-2"
          >
            <div className={`attendance_card `}>
              <div className="attendance_card_title">
                <img
                  src={"/assets/images/other/checking-attendance.png"}
                  alt={"Total Student"}
                  className="attendance_card_icon"
                />
                <h3>{"Total Student"}</h3>
              </div>

              <div className="attendance_card_count">
                {Attendence?.dashboard?.dashboard?.total_users || 0}
              </div>
            </div>
          </Col>{" "}
          <Col
            xl={3}
            lg={3}
            md={4}
            sm={6}
            xs={12}
            className="attendance_summary_col mb-2"
          >
            <div className={`attendance_card `}>
              <div className="attendance_card_title">
                <img
                  src={"/assets/images/other/absent.png"}
                  alt={"Total Absent"}
                  className="attendance_card_icon"
                />
                <h3>{"Total Absent"}</h3>
              </div>

              <div className="attendance_card_count">
                {Attendence?.dashboard?.dashboard?.total_absent || 0}
              </div>
            </div>
          </Col>{" "}
          <Col
            xl={3}
            lg={3}
            md={4}
            sm={6}
            xs={12}
            className="attendance_summary_col mb-2"
          >
            <div className={`attendance_card `}>
              <div className="attendance_card_title">
                <img
                  src={"/assets/images/other/checking-attendance.png"}
                  alt={"Total Present"}
                  className="attendance_card_icon"
                />
                <h3>{"Total Present"}</h3>
              </div>

              <div className="attendance_card_count">
                {Attendence?.dashboard?.dashboard?.total_present || 0}
              </div>
            </div>
          </Col>{" "}
          <Col
            xl={3}
            lg={3}
            md={4}
            sm={6}
            xs={12}
            className="attendance_summary_col mb-2"
          >
            <div className={`attendance_card `}>
              <div className="attendance_card_title">
                <img
                  src={"/assets/images/other/absent.png"}
                  alt={"Total Locked"}
                  className="attendance_card_icon"
                />
                <h3>{"Total Locked"}</h3>
              </div>

              <div className="attendance_card_count">
                {Attendence?.dashboard?.dashboard?.total_locked_users || 0}
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div className="section_filter_div">
        <div className="row align-items-center">
          {/* NAME */}
          <div className="col-lg-3 col-md-4 col-sm-6">
            <Form.Control
              type="text"
              placeholder="Search by Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="student_input"
            />
          </div>

          {/* DATE */}
          <div className="col-lg-3 col-md-4 col-sm-6">
            <Form.Control
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className="date_input"
            />
          </div>

          {/* ATTENDANCE */}
          <div className="col-lg-3 col-md-4 col-sm-6">
            <Select
              options={[
                {
                  value: "present",
                  label: "Present",
                },
                {
                  value: "absent",
                  label: "Absent",
                },
              ]}
              value={
                attendance
                  ? {
                      value: attendance,
                      label: attendance === "present" ? "Present" : "Absent",
                    }
                  : null
              }
              onChange={(selected) => setAttendance(selected?.value || "")}
              placeholder="Select Attendance"
              className="common_select"
              classNamePrefix="attendance"
              isSearchable={false}
              isClearable
            />
          </div>

          {/* SEARCH */}
          <div className="col-lg-2 col-md-3 col-sm-6">
            <button
              type="button"
              className="search_btn"
              onClick={() => fetch(1)}
            >
              Search
            </button>
          </div>

          {/* RESET */}
          <div className="col-lg-2 col-md-3 col-sm-6">
            <button type="button" className="reset_btn" onClick={handleReset}>
              Reset
            </button>
          </div>
        </div>
      </div>

      <div className="table-responsive custom-table-wrapper">
        <Table borderless className="custom-table text-center align-middle m-0">
          <thead>
            <tr>
              <th>No</th>
              <th>Name</th>
              <th>Date</th>
              <th>Time</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {Attendence.data.length > 0 ? (
              Attendence.data.map((row, index) => (
                <tr key={index}>
                  <td>
                    {(Attendence?.current_page - 1) * Attendence?.per_page +
                      index +
                      1}
                  </td>
                  <td className="fw-bold">{row.user_name}</td>
                  <td className="fw-bold">
                    {row?.attendance_date
                      ? new Date(row.attendance_date).toLocaleDateString(
                          "en-IN",
                        )
                      : "-"}
                  </td>

                  <td className="fw-bold">
                    {row?.attendance_date
                      ? new Date(row.attendance_date).toLocaleTimeString(
                          "en-IN",
                          {
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                          },
                        )
                      : "-"}
                  </td>
                  <td className="fw-bold">
                    <span
                      className={
                        row.attendance === "Present"
                          ? "attendance_status present"
                          : "attendance_status absent"
                      }
                    >
                      <span className="status_dot"></span>
                      {row.attendance}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center fw-bold">
                  No Data
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <div className="result_div">
        <p className="inner_text">
          Showing{" "}
          {Attendence?.data?.length > 0
            ? (Attendence.current_page - 1) * Attendence.per_page + 1
            : 0}{" "}
          to{" "}
          {(Attendence?.current_page - 1) * Attendence?.per_page +
            (Attendence?.data?.length || 0)}{" "}
          of {Attendence?.total || 0}
        </p>
      </div>
      {renderPagination(Attendence, handleCustomerPageChange)}
    </section>
  );
};

export default Attendance_List;
